import { Config } from '../../config'

export const fisherConfig: Config = {
  partner: 'fisher',
  catalog: 'fisher',
  displayName: 'Fisherbrand™ Chairs',
  accentColor: '#005DAA',
  host: 'fisherchair.com',
  extraAttributes: {
    hideQuoteRequest: true,
  }
}
